module.exports = __webpack_public_path__ + "img/antenna_color_2.f06ce7a7.svg";